import React from 'react';
import { AddressInputType } from '@domain/addresses/types/types';
import { createStyles } from '@/contexts/theme-context';
import { Typography } from '@usepepper/sprout-kit-ui';
import { View } from 'react-native';

interface AccountDetailHeaderProps {
  accountId: string | null;
  address: AddressInputType | null;
  name: string;
}

export const AccountDetailHeader: React.FC<AccountDetailHeaderProps> = ({
  accountId,
  address,
  name,
}) => {
  const [styles] = useStyles();

  // Some address fields might be null/undefined, so filter them out
  const formattedAddress = address
    ? [address.address, address.city, address.region].filter(Boolean).join(', ')
    : null;

  const hasSubtitle = Boolean(accountId || formattedAddress);
  const needSeparator = Boolean(accountId && formattedAddress);

  return (
    <View style={styles.container}>
      <Typography accessibilityRole="header" size="$lg" variant="heading">
        {name}
      </Typography>
      {hasSubtitle ? (
        <Typography color="$textSecondary" size="$sm" variant="body">
          {accountId}
          {needSeparator ? ' • ' : null}
          {formattedAddress}
        </Typography>
      ) : null}
    </View>
  );
};

const useStyles = createStyles(() => ({
  container: {
    gap: 2,
  },
}));
